import React, {Component} from 'react';
import {Container, Row, Col, Button} from 'reactstrap';


class Page404 extends Component {
    render() {
        return (
            <Container className="page-404">
                <Row className="justify-content-center">
                    <Col md="6">
                        <div className="clearfix">
                            <h1 className="float-left display-3 mr-4 white-text-color">404</h1>
                            <h4 className="pt-3 golden-text-color">Oops! You're lost.</h4>
                            <p className="text-muted float-left">The page you are looking for was not found.</p>
                        </div>
                    </Col>
                </Row>
            </Container>
        );
    }
}


export default Page404;



// WEBPACK FOOTER //
// ./src/containers/Page404.js